import { render, staticRenderFns } from "./client-fields.html?vue&type=template&id=738477d8&scoped=true&"
import script from "./client-fields.ts?vue&type=script&lang=js&"
export * from "./client-fields.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738477d8",
  null
  
)

export default component.exports